/*!
 * devextreme-angular
 * Version: 22.1.11
 * Build date: Mon Aug 28 2023
 *
 * Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/* tslint:disable:max-line-length */


import {
    Component,
    NgModule,
    Host,
    SkipSelf,
    Input
} from '@angular/core';





import {
    NestedOptionHost,
} from 'devextreme-angular/core';
import { CollectionNestedOption } from 'devextreme-angular/core';


@Component({
    selector: 'dxi-location',
    template: '',
    styles: [''],
    providers: [NestedOptionHost]
})
export class DxiLocationComponent extends CollectionNestedOption {
    @Input()
    get lat(): number {
        return this._getOption('lat');
    }
    set lat(value: number) {
        this._setOption('lat', value);
    }

    @Input()
    get lng(): number {
        return this._getOption('lng');
    }
    set lng(value: number) {
        this._setOption('lng', value);
    }

    @Input()
    get col(): number {
        return this._getOption('col');
    }
    set col(value: number) {
        this._setOption('col', value);
    }

    @Input()
    get colspan(): number | undefined {
        return this._getOption('colspan');
    }
    set colspan(value: number | undefined) {
        this._setOption('colspan', value);
    }

    @Input()
    get row(): number {
        return this._getOption('row');
    }
    set row(value: number) {
        this._setOption('row', value);
    }

    @Input()
    get rowspan(): number | undefined {
        return this._getOption('rowspan');
    }
    set rowspan(value: number | undefined) {
        this._setOption('rowspan', value);
    }

    @Input()
    get screen(): string | undefined {
        return this._getOption('screen');
    }
    set screen(value: string | undefined) {
        this._setOption('screen', value);
    }


    protected get _optionPath() {
        return 'location';
    }


    constructor(@SkipSelf() @Host() parentOptionHost: NestedOptionHost,
            @Host() optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }



    ngOnDestroy() {
        this._deleteRemovedOptions(this._fullOptionPath());
    }

}

@NgModule({
  declarations: [
    DxiLocationComponent
  ],
  exports: [
    DxiLocationComponent
  ],
})
export class DxiLocationModule { }
